function e(n) {
  return {
    name: "Backus–Naur Form",
    contains: [
      // Attribute
      {
        className: "attribute",
        begin: /</,
        end: />/
      },
      // Specific
      {
        begin: /::=/,
        end: /$/,
        contains: [
          {
            begin: /</,
            end: />/
          },
          // Common
          n.C_LINE_COMMENT_MODE,
          n.C_BLOCK_COMMENT_MODE,
          n.APOS_STRING_MODE,
          n.QUOTE_STRING_MODE
        ]
      }
    ]
  };
}
export {
  e as default
};
